import PropTypes from 'prop-types'
import React from 'react'
import ExternalInstitutionCitizenField from '../procedure_managements/ExternalInstitutionCitizenField'

const Citizen = props => {
  const { index, name, question, disabled = false, margin } = props
  return <ExternalInstitutionCitizenField index={index} {...question} name={name} disabled={disabled} margin={margin} />
}

const ExternalInstitutionQuestion = {
  Citizen,
  name: 'ExternalInstitutionQuestion'
}

export default ExternalInstitutionQuestion

Citizen.propTypes = {
  disabled: PropTypes.bool,
  index: PropTypes.number,
  margin: PropTypes.string,
  name: PropTypes.string,
  question: PropTypes.object
}
